import "./SmartUnderline.css"; // L'import magique est ici

import React, { useRef, useEffect, useState } from "react";

function SmartUnderline({ children, className = "", isReady = true }) {
  const textRef = useRef(null);
  const [lineWidth, setLineWidth] = useState(0);

useEffect(() => {
  const updateWidth = () => {
    const el = textRef.current;
    if (!el) return;

    const range = document.createRange();
    range.selectNodeContents(el);

    const rects = range.getClientRects();
    if (rects.length === 0) return;

    // 1. Récupère la largeur de la dernière ligne
    const lastRectWidth = rects[rects.length - 1].width;

    // 2. Condition : si l'écran est plus petit que 768px (mobile/tablette), on réduit à 80%
    // Sinon (Desktop), on garde 100%
    if (window.innerWidth >= 768) {
      setLineWidth(lastRectWidth * 0.8);
    } else {
      setLineWidth(lastRectWidth);
    }
  };

    // On attend un micro-délai pour que les polices soient bien rendues
    const timer = setTimeout(updateWidth, 60);
    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
      clearTimeout(timer);
    };
  }, [children, isReady]); // Re-calcul si le texte change ou si la section s'active

  return (
    <h1 className={`smart-title-root ${className}`} style={{ textAlign: 'center', position: 'relative', display: 'block' }}>
      <span ref={textRef} className="smart-title-text" style={{ display: 'inline' }}>
        {children}
      </span>

      <span
        className={`smart-title-underline ${isReady ? "active" : ""}`}
        style={{ 
          width: lineWidth,
          left: '50%',
          transform: `translateX(-50%) scaleX(${isReady ? 1 : 0})`,
          position: 'absolute',
          bottom: '-11px',
          height: '1.5px',
          transition: 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.2s, width 0.3s ease'
        }}
      />
    </h1>
  );
}

export default SmartUnderline;